import React from "react";
import { ShieldCheck, Truck, Hammer } from "lucide-react";
import { SectionHeading } from "../SectionHeading";

const VALUES = [
  {
    icon: ShieldCheck,
    title: "Quality Guaranteed",
    body: "Mill-direct sourcing and rigorous QA ensure every board, beam, and bundle meets spec - no surprises on the truck, no surprises on the job.",
    bg: "bg-[#0A192F]",
    text: "text-white",
    accent: "text-[#D4AF37]",
    iconBg: "bg-[#D4AF37]",
    iconColor: "text-[#0A192F]",
  },
  {
    icon: Truck,
    title: "Reliable Delivery",
    body: "On-time job-site delivery with a fleet built for tight schedules and tighter timelines - staged the way your crew works.",
    bg: "bg-[#D4AF37]",
    text: "text-[#0A192F]",
    accent: "text-[#0A192F]",
    iconBg: "bg-[#0A192F]",
    iconColor: "text-[#D4AF37]",
  },
  {
    icon: Hammer,
    title: "Built for Builders",
    body: "We supply the way contractors work - fast quotes, clear pricing, a single point of contact, and zero runaround from yard to site.",
    bg: "bg-[#0A192F]",
    text: "text-white",
    accent: "text-[#D4AF37]",
    iconBg: "bg-[#D4AF37]",
    iconColor: "text-[#0A192F]",
  },
];

const ValueCard = ({ icon: Icon, title, body, bg, text, iconBg, iconColor, testId }) => (
  <div
    data-testid={testId}
    className={`${bg} ${text} p-7 sm:p-10 lg:p-11 hover-lift transition-transform`}
  >
    <div className={`w-14 h-14 sm:w-16 sm:h-16 ${iconBg} flex items-center justify-center`}>
      <Icon className={iconColor} size={28} strokeWidth={2.25} />
    </div>
    <h3 className={`mt-5 sm:mt-7 font-display font-black text-xl sm:text-2xl lg:text-3xl tracking-tight ${text}`}>
      {title}
    </h3>
    <p className={`mt-3 sm:mt-4 text-sm sm:text-base leading-relaxed ${text} opacity-90`}>{body}</p>
  </div>
);

export const ValuesSection = () => (
  <section className="py-20 sm:py-24 lg:py-32 bg-white" data-testid="home-values">
    <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-10">
      <SectionHeading
        eyebrow="Why CM Lindley"
        title="A supplier that thinks like a builder."
        subtitle="CM Lindley exists to make material supply painless for the people doing the actual building. We are driven by the details that contractors quietly care about - grade accuracy, on-time deliveries, single-point ownership, transparent pricing - so your crew can focus on the work, not chasing materials. Whether you need a full lumber package, a structural steel takeoff, or a job-site delivery on short notice, you get the same hands-on partnership every time."
      />
      <div className="mt-12 sm:mt-16 grid md:grid-cols-3 gap-5 sm:gap-6">
        {VALUES.map((v, i) => (
          <ValueCard key={v.title} {...v} testId={`value-card-${i}`} />
        ))}
      </div>
    </div>
  </section>
);

export default ValuesSection;
